<div class="container single-view" id="add-category">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/categories/" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'CATEGORIES.BTN_BACK_TO_CATEGORY' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-category-create-category-title" class="section-title">{{ 'CATEGORY_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-category-create-category-subtitle" class="section-subtitle mt-1 text-base">{{ 'CATEGORY_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form data-testid="add-category-create-category-form" class="mt-0" [formGroup]="categoryForm">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="add-category-details-title" class="border-b pb-3">{{ 'CATEGORY_CREATE.CATEGORY_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-category-field-name" class="block text-sm" for="name">{{ 'CATEGORY_CREATE.NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-category-name-input" type="text" id="name" formControlName="name" autocomplete="off">
                  @if (categoryForm.get('name')?.invalid && categoryForm.get('name')?.touched) {
                    <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-category-field-code" class="block text-sm" for="code">{{ 'CATEGORY_CREATE.CODE' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-category-code-input" type="text" id="code" formControlName="code" autocomplete="off">
                  @if (categoryForm.get('code')?.invalid && categoryForm.get('code')?.touched) {
                    <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <span data-testid="add-category-field-hasParent" class="block text-sm mb-3" for="hasParentCategory">{{ 'CATEGORY_CREATE.HAS_PARENT' | translate }}</span>
                  <label data-testid="add-category-has-parent-yes-label" class="inline-flex mr-6">
                    <p-radioButton data-testid="add-category-has-parent-yes" name="hasParentCategory" value="true" formControlName="hasParentCategory" inputId="yes" />
                    <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                  </label>
                  <label data-testid="add-category-has-parent-no-label" class="inline-flex mr-2">
                    <p-radioButton data-testid="add-category-has-parent-no" name="hasParentCategory" value="false" formControlName="hasParentCategory" inputId="no" />
                    <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                  </label>
                </div>
                <div data-testid="add-category-field-parent-category" class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3"
                  [ngClass]="{'disabled': categoryForm.get('hasParentCategory')?.value == 'false'}">
                  <label class="block text-sm" for="categoryId">{{ 'CATEGORY_CREATE.PARENT_CATEGORY' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="parentcategory"
                    [placeholder]="'CATEGORY_CREATE.SELECT_PARENT_PLACEHOLDER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="comboData.rowsPerPageOption || 5"
                    [totalCount]="comboData.totalRecords"
                    [totalPages]="getComboTotalPages()"
                    [options]="comboData.list"
                    formControlName="parentCategoryId"
                    (onLazyLoad)="onLazyLoadComboData($event)">
                  </app-custom-dropdown>

                  @if (categoryForm.errors?.['requiredCategory'] && isCategoryRequired()) {
                    <small data-testid="category-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-category-create-category-button" id="btn-create-category" class="btn primary-btn" [disabled]="categoryForm.invalid"
                      (click)="submitForm()">{{
                    'CATEGORY_CREATE.BTN_CREATE_CATEGORY' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
